import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";

const AddCustomers = () => {
  const email = Cookies.get("userEmail");
  const [data, setData] = useState();
  useEffect(() => {
    if (email) {
      franchiseAdminAPI
        .getFranchiseDetailsByEmail(email)
        .then((res) => {
          setData({
            referralCode: res.data.referralCode,
          });
        })
        .catch((err) => {
          console.error("Error fetching franchise details:", err);
        });
    }
  }, []);

  return <div>
    <h1>Add Customers Page</h1>
    <p>Referral Code: {data?.referralCode}</p>
  </div>;
};

export default AddCustomers;
